export const dispatchCustomEvent = (
  typeArg: string,
  eventInitDict?: CustomEventInit<unknown> | undefined
) => {
  window.dispatchEvent(new CustomEvent(typeArg, eventInitDict));
};
